import React, { useState } from 'react';
import api from '@/lib/api';
import { Mail, AlertCircle, CheckCircle2 } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await api.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Aanvraag mislukt, probeer het opnieuw');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex h-screen items-center justify-center bg-gradient-to-br from-tw1-brand-navy-top to-tw1-brand-navy font-sans px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center text-center text-white">
          <img src="/images/logo.png" alt="Truckwash1" className="h-14 w-auto object-contain mb-4" />
          <h1 className="text-3xl font-bold tracking-tight">SmartRoster</h1>
        </div>

        <div className="rounded-xl bg-white p-8 shadow-2xl">
          <h2 className="text-xl font-semibold text-slate-900 mb-2 text-center">Wachtwoord vergeten</h2>
          <p className="mb-6 text-center text-sm text-slate-500">
            Vul je e-mailadres in — we sturen je een link om een nieuw wachtwoord in te stellen.
          </p>

          {done ? (
            <div data-testid="forgot-password-success" className="flex items-start gap-2 rounded-md border border-emerald-200 bg-emerald-50 px-3 py-3 text-sm text-emerald-800">
              <CheckCircle2 size={16} className="mt-0.5 shrink-0" />
              <span>Als dit e-mailadres bekend is, ontvang je een reset-link. Check je inbox.</span>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1.5">E-mail</label>
                <input
                  id="email" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)} autoComplete="username"
                  data-testid="forgot-password-email"
                  className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm shadow-sm focus:border-tw1-accent-gold focus:outline-none focus:ring-2 focus:ring-tw1-accent-gold/30"
                  placeholder="jouwnaam@truckwash1group.nl"
                />
              </div>
              {error && (
                <div role="alert" data-testid="forgot-password-error" className="flex items-start gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
                  <AlertCircle size={16} className="mt-0.5 shrink-0" />
                  <span>{error}</span>
                </div>
              )}
              <button
                type="submit" disabled={submitting} data-testid="forgot-password-submit"
                className="flex w-full items-center justify-center gap-2 rounded-md bg-tw1-accent-gold px-4 py-2.5 text-sm font-bold text-tw1-brand-navy shadow hover:bg-tw1-accent-gold-dark disabled:opacity-60 transition-colors"
              >
                <Mail size={16} />
                {submitting ? 'Versturen…' : 'Reset-link versturen'}
              </button>
            </form>
          )}

          <p className="mt-6 text-center text-xs text-slate-500">
            <a href="/login" className="font-medium text-tw1-brand-navy hover:underline" data-testid="link-back-to-login">
              Terug naar inloggen
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
